import React from "react";
import PropTypes from "prop-types";

/**
 * 셀러 컬렉션 헤더 컴포넌트
 * 컬렉션의 이미지 헤더를 렌더링합니다.
 */
const SellerCollectionHeader = ({ collection, loading }) => {
  if (loading) {
    return <div className="header-loading"></div>;
  }

  if (!collection || !collection.resizedBigImage) {
    return null;
  }

  return (
    <div className="collection-header">
      <img
        src={collection.resizedBigImage}
        alt={collection.title || "컬렉션 이미지"}
        className="header-image"
      />
    </div>
  );
};

SellerCollectionHeader.propTypes = {
  collection: PropTypes.shape({
    title: PropTypes.string,
    resizedBigImage: PropTypes.string,
  }),
  loading: PropTypes.bool,
};

export default SellerCollectionHeader;
